import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getMyWorksToAdministrate(companyId, query) {
  return dataTransferWrap(
    ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE,
    dtConfig[ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE].getMyWorksToAdministrate,
    {
      urlParams: {
        companyId,
      },
      params: query,
    },
  )
}

export default {
  getMyWorksToAdministrate,
}